import { TopLevelCategory } from 'src/WebApiController';

/**
 * Category segment for strategy calculator preset lookup.
 *
 * Maps to the three genre keys in the Snowflake data:
 *   - 'sports'   — all sporting events (MLB, NBA, NFL, NHL, etc.)
 *   - 'concerts' — concerts and music festivals
 *   - 'theatre'  — theatre performances
 *   - 'all'      — fallback for unrecognized categories
 */
export type CategorySegment = 'sports' | 'concerts' | 'theatre' | 'all';

/**
 * Determines the category segment for an event based on its top-level genre.
 *
 * Maps to one of three Snowflake data genres (sports / concerts / theatre).
 * Festivals are grouped with concerts. Unrecognized genres fall back to 'all'.
 */
export const getCategorySegment = (
  genre: TopLevelCategory | undefined,
  _parentCategoryId: number | undefined
): CategorySegment => {
  if (genre === TopLevelCategory.Sports) return 'sports';
  if (genre === TopLevelCategory.Concert) return 'concerts';
  if (genre === TopLevelCategory.Festival) return 'concerts';
  if (genre === TopLevelCategory.Theatre) return 'theatre';

  return 'all';
};
